<template>
    <div class="w-full relative layout-selection">
        <div class="flex items-center mb-3 layout-select-container"
             v-if="displayLabel">
            <IconLayoutSelection class="text-primary layout-select-icon"/>
            <div class="mx-1 main-text-color text-sm font-medium truncate layout-select-label">
                {{ label ? label : $t('layout.layoutSelection') }}
            </div>
        </div>
        <el-select v-model="selectedLayout"
                   value-key="LayoutID"
                   label-key="LayoutName"
                   placeholder=" "
                   :filterable="filterable"
                   class="layout-select flex items-center text-sm font-medium w-full"
        >
            <div class="options-wrapper">
                <el-option v-for="layout in filteredLayouts"
                           class="flex items-center justify-between truncate"
                           :value="layout.LayoutID"
                           :label="layout.LayoutName"
                           :key="layout.LayoutID">
                    <div
                        class="truncate flex justify-between h-13 shadow-base w-full px-2 rounded border border-transparent hover:border-primary main-bg-light">
                        <div @click="onChooseLayout(layout)"
                             class="flex flex-col flex-1">
                            <p class="-mt-1 text-md truncate flex items-center">
                                <el-tooltip :content="$t('layout.defaultLayoutWarning')"
                                            v-if="layout.LayoutAccountID === 0"
                                            placement="top">
                                    <AlertTriangleIcon class="text-orange-350 cursor-help w-4-5 h-4-5 mx-2"/>
                                </el-tooltip>
                                <span class="main-text-color">
                                    {{ layout.LayoutName }}
                                </span>
                            </p>
                            <div class="flex w-full flex-row pb-2 items-center">
                                <div v-for="(group, index) in getColorParameters(layout)"
                                     class="w-1/3 h-2"
                                     :key="`${layout.LayoutID}_${index}_${group.JPath}`">
                                    <div class="w-full h-2 rounded border"
                                         :style="getIndicatorStyles(group)"/>
                                </div>
                            </div>
                        </div>
                    </div>
                </el-option>
            </div>
        </el-select>
    </div>
</template>
<script>
    import { Option, Select } from 'element-ui'
    import { AlertTriangleIcon } from 'vue-feather-icons'
    import { DEFAULT_GROUP_KEYS } from '@/views/DashboardSettings/LayoutManagement/layout-management'

    export default {
        components: {
            AlertTriangleIcon,
            [Select.name]: Select,
            [Option.name]: Option,
        },
        props: {
            activeLayout: {
                type: Object,
                default: () => ({}),
            },
            displayLabel: {
                type: Boolean,
                default: true,
            },
            filterable: {
                type: Boolean,
                default: true,
            },
            hideLayoutId: {
                type: Number,
                default: 0,
            },
            defaultLayout: {
                type: Number,
                default: null,
            },
            label: {
                type: String,
                default: '',
            }
        },
        data() {
            return {
                groupKeys: DEFAULT_GROUP_KEYS,
                selectedLayout: this.defaultLayout,
            }
        },
        computed: {
            activeAccountLayouts() {
                return this.$store.getters['layout/getActiveLayouts']
            },
            filteredLayouts() {
                if (!this.hideLayoutId) {
                    return this.activeAccountLayouts
                }
                return this.activeAccountLayouts.filter(layout => layout.LayoutID.toString() !== this.hideLayoutId.toString())
            },
        },
        methods: {
            onChooseLayout(layout) {
                this.selectedLayout = layout
                this.$emit('on-chose-layout', layout)
            },
            getIndicatorStyles(config) {
                return {
                    'background-color': config.Value,
                }
            },
            getColorParameters(layout) {
                if (!layout) {
                    return []
                }
                const group = this.groupKeys['Colors']
                return this.getGroupedParameters(group, layout)
            },
            getGroupedParameters(group, layout) {
                return layout.LayoutParametersList.filter((el) => group.includes(el.LayoutParameterName))
            },
        },
        watch: {
            activeLayout: {
                immediate: true,
                deep: true,
                handler(layout) {
                    this.selectedLayout = layout.LayoutID
                }
            },
        },
    }
</script>
<style lang="scss" scoped>
.el-select-dropdown {
    ::-webkit-scrollbar {
        width: 0;
        height: 0;
    }

    .el-select-dropdown__item {
        @apply h-14 my-2;
    }

    overflow: hidden;
}
</style>
